// The scoring formula — the game's "speed first" thesis, kept pure & tested
// like speed.ts/press.ts. gain = chips × mult, mult = 1 + speedBonus + streakBonus.

export interface ScoreBreakdown {
  chips: number;
  /** 0–5, rounded from the speed meter (1 = answered instantly) */
  speedBonus: number;
  /** +1 per 3 streak */
  streakBonus: number;
  mult: number;
  gain: number;
}

export function scoreFor(baseChips: number, speedMeter: number, streak: number): ScoreBreakdown {
  const speedBonus = Math.round(speedMeter * 5);
  const streakBonus = Math.floor(streak / 3);
  const mult = 1 + speedBonus + streakBonus;
  return { chips: baseChips, speedBonus, streakBonus, mult, gain: baseChips * mult };
}
